"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SETTINGS_TABLES = void 0;
exports.appSettingsModel = appSettingsModel;
exports.artifactManifestMatchesAppBase = artifactManifestMatchesAppBase;
exports.appSettingsToRows = appSettingsToRows;
exports.appSettingsState = appSettingsState;
exports.appSettingsTablesFor = appSettingsTablesFor;
exports.appSettingsPartFromRows = appSettingsPartFromRows;
exports.appsInTrashFromRows = appsInTrashFromRows;
exports.rebaseAppSettings = rebaseAppSettings;
exports.appSettingsChangeHasTarget = appSettingsChangeHasTarget;
exports.appSettingsFromRows = appSettingsFromRows;
const app_base_config_1 = require("./app-base-config");
const app_base_contract_1 = require("./app-base-contract");
const app_settings_engine_1 = require("./app-settings-engine");
const app_stored_files_1 = require("./app-stored-files");
/**
 * The tables App Container settings are stored in. Every collection of
 * objects in {@link AppBaseConfigSchema} is a table of its own; columns come
 * from the schema. JSON text is kept for free values only: the contract of an
 * Agent Action, formulas, free metadata and props, the input value of an
 * automation, the live data scope (an option or a list of options), the
 * attachment downloads and the App rules, which existing containers hold no
 * table for.
 * `appArtifact.manifest` is stored once, as `appBase`.
 */
exports.APP_SETTINGS_TABLES = [
    {
        key: 'container',
        title: 'App',
        paths: [''],
        json: [
            'appBase.delivery.liveData.scope',
            'appBase.attachmentDownloads[]',
            'appBase.rules',
            'appBase.derivedSources',
        ],
        skip: ['dataSources', 'appArtifact.manifest'],
    },
    {
        key: 'databaseBindings',
        title: 'Tabellenbindungen',
        paths: ['databaseBindings{}'],
        titleField: 'label',
    },
    {
        key: 'pendingDatabaseAttachments',
        title: 'Wartende Tabellenbindungen',
        paths: ['pendingDatabaseAttachments{}'],
        titleField: 'label',
    },
    {
        key: 'pendingDatabaseAttachmentColumns',
        title: 'Wartende App-Spalten',
        paths: ['pendingDatabaseAttachments{}.createColumns[]'],
        keyField: 'columnId',
        titleField: 'name',
        json: ['data'],
    },
    {
        key: 'mounts',
        title: 'Einbindungen',
        paths: ['appComposition.mounts[]'],
        keyField: 'mountId',
        titleField: 'mountId',
        json: ['props{}'],
    },
    {
        key: 'mountBindings',
        title: 'Einbindungs-Tabellen',
        paths: ['appComposition.mounts[].bindings{}'],
    },
    {
        key: 'apps',
        title: 'App Modules',
        paths: ['appDefinitions{}'],
        titleField: 'title',
        // The removed mount is restored as it was, never edited in the table; the
        // flow plan is one document of its own.
        json: ['trash.mount', 'attachmentDownloads[]', 'rules', 'flowPlan'],
    },
    {
        key: 'routes',
        title: 'Seiten',
        paths: ['appDefinitions{}.routes[]'],
        keyField: 'route.path',
        titleField: 'route.title',
    },
    {
        key: 'routeTableAccess',
        title: 'Seiten-Tabellenrechte',
        paths: ['appDefinitions{}.routes[].route.access.tables{}'],
    },
    {
        key: 'buildingBlocks',
        title: 'Bausteine',
        paths: ['appDefinitions{}.routes[].buildingBlockRefs[]'],
        keyField: 'id',
        titleField: 'label',
        json: ['metadata{}'],
    },
    {
        key: 'resources',
        title: 'App-Tabellen',
        paths: ['appDefinitions{}.resources[]'],
        keyField: 'sourceKey',
        titleField: 'label',
    },
    {
        key: 'commands',
        title: 'Aktionen',
        paths: ['appDefinitions{}.commands[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'commandFields',
        title: 'Aktionsfelder',
        paths: [
            'appDefinitions{}.commands[]|rowInsert.fields[]',
            'appDefinitions{}.commands[]|automationRun.fields[]',
            'appDefinitions{}.commands[]|ownRowChange.fields[]',
        ],
        titleField: 'label',
    },
    {
        key: 'commandNewRowFields',
        title: 'Weitere Zellen neuer Zeilen',
        paths: ['appDefinitions{}.commands[]|attachmentUpdate.newRowFields[]'],
        titleField: 'columnId',
    },
    {
        key: 'commandInputBindings',
        title: 'Aktions-Eingaben',
        paths: ['appDefinitions{}.commands[]|automationRun.inputBindings[]'],
        json: ['value'],
    },
    {
        key: 'agentActions',
        title: 'Agent Actions',
        paths: ['appDefinitions{}.agentActions[]'],
        keyField: 'id',
        titleField: 'displayName',
        json: ['contract'],
    },
    {
        key: 'agentActionBindings',
        title: 'Agent-Action-Bindungen',
        paths: ['appDefinitions{}.agentActions[].bindings[]'],
        keyField: 'bindingKey',
        titleField: 'bindingKey',
    },
    {
        key: 'agentActionLookupKeys',
        title: 'Agent-Action-Suchschlüssel',
        paths: ['appDefinitions{}.agentActions[].bindings[].lookupKeys[]'],
        keyField: 'name',
        titleField: 'name',
    },
    {
        key: 'exports',
        title: 'Exporte',
        paths: ['appDefinitions{}.exports[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'navigation',
        title: 'Navigation',
        paths: [
            'appDefinitions{}.navigation[]',
            'appDefinitions{}.navigationActions[]',
            'appDefinitions{}.topBar[]',
        ],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'files',
        title: 'Dateien',
        paths: ['appDefinitions{}.files{}'],
        titleField: 'path',
    },
    {
        key: 'sourceFiles',
        title: 'Quelldateien',
        paths: ['sourceFiles.rows{}'],
        titleField: 'path',
    },
    {
        key: 'pageAccess',
        title: 'App-Seitenrechte',
        paths: ['pageAccess.pages{}'],
    },
    {
        key: 'pageAccessTables',
        title: 'App-Seiten-Tabellenrechte',
        paths: ['pageAccess.pages{}.tables{}'],
    },
    {
        key: 'pageAccessGroups',
        title: 'App-Seiten-Gruppen',
        paths: ['pageAccess.pages{}.groups[]'],
    },
    {
        key: 'pageAccessRefresh',
        title: 'App-Seiten-Aktualisierung',
        paths: ['pageAccess.refresh.pages{}'],
    },
    {
        key: 'containerPages',
        title: 'App-Seiten',
        paths: ['pages[]'],
        keyField: 'id',
        titleField: 'path',
        json: ['titleFormula'],
    },
    {
        key: 'containerNavigation',
        title: 'App-Navigation',
        paths: ['navigation[]'],
        keyField: 'id',
        json: ['labelFormula'],
    },
    {
        key: 'manifestRoutePolicies',
        title: 'Manifest-Cache-Regeln',
        paths: ['appBase.delivery.routePolicies[]'],
        // Mixed page audiences can require distinct policies on the same endpoint.
        keyField: ['path', 'cacheClass'],
        titleField: 'path',
    },
    {
        key: 'manifestDeliveries',
        title: 'Manifest-Auslieferungen',
        paths: ['appBase.appDeliveries[]'],
        keyField: 'mountId',
        titleField: 'mountId',
        json: ['delivery.liveData.scope'],
    },
    {
        key: 'manifestDeliveryRoutePolicies',
        title: 'Manifest-Auslieferungs-Cache-Regeln',
        paths: ['appBase.appDeliveries[].delivery.routePolicies[]'],
        keyField: 'path',
        titleField: 'path',
    },
    {
        key: 'manifestRoutes',
        title: 'Manifest-Routen',
        paths: ['appBase.routes[]'],
        keyField: 'path',
        titleField: 'path',
    },
    {
        key: 'manifestRouteTableAccess',
        title: 'Manifest-Routen-Tabellenrechte',
        paths: ['appBase.routes[].access.tables{}'],
    },
    {
        key: 'manifestNavigation',
        title: 'Manifest-Navigation',
        paths: ['appBase.navigation[]', 'appBase.topBar[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'manifestActions',
        title: 'Manifest-Aktionen',
        paths: ['appBase.actions[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'manifestActionFields',
        title: 'Manifest-Aktionsfelder',
        paths: [
            'appBase.actions[]|rowInsert.fields[]',
            'appBase.actions[]|automationRun.fields[]',
            'appBase.actions[]|ownRowChange.fields[]',
        ],
        titleField: 'label',
    },
    {
        key: 'manifestActionInputBindings',
        title: 'Manifest-Aktions-Eingaben',
        paths: ['appBase.actions[]|automationRun.inputBindings[]'],
        json: ['value'],
    },
    {
        key: 'manifestActionNewRowFields',
        title: 'Manifest: weitere Zellen neuer Zeilen',
        paths: ['appBase.actions[]|attachmentUpdate.newRowFields[]'],
        titleField: 'columnId',
    },
    {
        key: 'capabilities',
        title: 'Fähigkeiten',
        paths: ['appBase.capabilities[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'documentExports',
        title: 'Manifest-Exporte',
        paths: ['appBase.documentExports[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'routeSeo',
        title: 'Routen-SEO',
        paths: ['appBase.routeSeo[]'],
        keyField: 'id',
        titleField: 'routePath',
    },
    {
        key: 'interactionControls',
        title: 'Bedienelemente',
        paths: ['appBase.interaction.controls[]'],
        keyField: 'id',
        titleField: 'id',
    },
    {
        key: 'artifactFiles',
        title: 'Artefakt-Dateien',
        paths: ['appArtifact.files{}'],
        titleField: 'path',
    },
    {
        key: 'routeModules',
        title: 'Seitenmodule',
        paths: ['appArtifact.routeModules[]'],
        keyField: 'id',
        titleField: 'label',
    },
    {
        key: 'moduleBuildingBlocks',
        title: 'Seitenmodul-Bausteine',
        paths: ['appArtifact.routeModules[].buildingBlockRefs[]'],
        keyField: 'id',
        titleField: 'label',
        json: ['metadata{}'],
    },
    {
        key: 'notFoundPages',
        title: 'Nicht-gefunden-Seiten',
        paths: ['appArtifact.notFoundPages[]'],
        keyField: 'mountId',
        titleField: 'mountId',
    },
];
let model;
let codec;
function appSettingsModel() {
    model ??= new app_settings_engine_1.SettingsModel(app_base_config_1.AppBaseConfigSchema, exports.APP_SETTINGS_TABLES);
    return model;
}
function appSettingsCodec() {
    codec ??= new app_settings_engine_1.SettingsCodec(appSettingsModel());
    return codec;
}
/** Settings keep one manifest: the artifact manifest, if any, is appBase. */
function artifactManifestMatchesAppBase(config) {
    const artifact = config.appArtifact;
    return (!artifact ||
        JSON.stringify(artifact.manifest) === JSON.stringify(config.appBase));
}
/** The rows of every settings table of one App Container; its row id is the viewId. */
function appSettingsToRows(viewId, config, state) {
    if (!artifactManifestMatchesAppBase(config)) {
        throw new app_settings_engine_1.SettingsMappingError(`App ${viewId}: the artifact manifest differs from appBase; settings keep one manifest`);
    }
    assertAppFilesStoredAsBlobs(viewId, config);
    return appSettingsCodec().encode(viewId, config, state);
}
/**
 * A file row of the settings names its workspace blob and never holds the
 * bytes: the server stores App files as blobs before the settings are
 * written (storeAppBaseConfigFiles), so a row with a body is refused.
 */
function assertAppFilesStoredAsBlobs(viewId, config) {
    for (const file of (0, app_stored_files_1.appBaseConfigFiles)(config)) {
        if (file.text === undefined && file.storageKey !== undefined)
            continue;
        throw new app_settings_engine_1.SettingsMappingError(`App ${viewId}: the file ${file.path} is stored without its blob; store App files as workspace blobs first`);
    }
}
/** Generation and revision the container row of an App Container names. */
function appSettingsState(viewId, rows) {
    return appSettingsCodec().state(viewId, rows);
}
/**
 * The Config tables that hold the given top-level fields of the settings,
 * with the container table. Every table below a field comes along, so the
 * rows decode on their own.
 */
function appSettingsTablesFor(fields) {
    return exports.APP_SETTINGS_TABLES.filter(def => def.paths.includes('') ||
        def.paths.some(path => fields.includes(path.split(/[.{[|]/)[0]))).map(def => def.key);
}
/**
 * The fields some Config tables hold, decoded without checking the whole
 * settings: for readers that need a part only and read only its tables.
 */
function appSettingsPartFromRows(viewId, rows) {
    return appSettingsCodec().decode(viewId, rows);
}
/**
 * The Apps of one container that lie in the trash, from its container row
 * and its Config table `apps`.
 */
function appsInTrashFromRows(viewId, rows) {
    const part = appSettingsPartFromRows(viewId, rows);
    return Object.values(part.appDefinitions ?? {}).flatMap(definition => definition.trash === undefined
        ? []
        : [
            {
                appId: definition.appId,
                title: definition.title,
                trash: app_base_contract_1.AppDefinitionTrashSchema.parse(definition.trash),
            },
        ]);
}
/**
 * A change from `base` to `next`, applied to the settings stored now: what
 * the change left as it was takes the stored value, objects merge key by
 * key, lists of a Config table with a key field merge item by item (see
 * {@link rebaseList}), anything else the change set wins. Every writer that
 * writes again after another one wrote applies its change this way.
 */
function rebaseAppSettings(base, next, current) {
    const rebased = rebaseValue(base, next, current, '');
    // The artifact manifest is stored once, as appBase: the merged appBase is
    // the manifest of a change that kept one. A change whose own manifest
    // differs stays as it is, so the write refuses it.
    return rebased.appArtifact &&
        rebased.appBase &&
        artifactManifestMatchesAppBase(next)
        ? {
            ...rebased,
            appArtifact: { ...rebased.appArtifact, manifest: rebased.appBase },
        }
        : rebased;
}
/**
 * Whether the settings stored now still hold every object the change from
 * `base` to `next` edits inside: a restore that removed one leaves the
 * change without its target, and applying it would bring a part back.
 */
function appSettingsChangeHasTarget(base, next, current) {
    return hasTarget(base, next, current, '');
}
const KEYED_LISTS = new Map(exports.APP_SETTINGS_TABLES.flatMap(def => def.keyField ? def.paths.map(path => [path, def.keyField]) : []));
/** Paths of the maps the Config tables hold (`field{}`). */
const MAPS = new Set(exports.APP_SETTINGS_TABLES.flatMap(def => def.paths.flatMap(path => [...path.matchAll(/\{\}/g)].map(match => path.slice(0, match.index + 2)))));
/** Path of the value under `key` of the object or map at `path`. */
function childPath(path, key) {
    if (MAPS.has(`${path}{}`))
        return `${path}{}`;
    return path === '' ? key : `${path}.${key}`;
}
function hasTarget(base, next, current, path) {
    if (sameValue(next, base))
        return true;
    const keyField = KEYED_LISTS.get(`${path}[]`);
    if (keyField && Array.isArray(base) && Array.isArray(next)) {
        if (!Array.isArray(current))
            return false;
        const stored = itemsByKey(current, keyField, path);
        const before = itemsByKey(base, keyField, path);
        for (const [key, item] of itemsByKey(next, keyField, path)) {
            const was = before.get(key);
            if (was === undefined)
                continue;
            if (!stored.has(key)) {
                if (!sameValue(item, was))
                    return false;
                continue;
            }
            if (!hasTarget(was, item, stored.get(key), `${path}[]`))
                return false;
        }
        return true;
    }
    if (!isPlainRecord(base) || !isPlainRecord(next))
        return true;
    if (!isPlainRecord(current))
        return false;
    for (const key of new Set([...Object.keys(base), ...Object.keys(next)])) {
        if (!hasTarget(base[key], next[key], current[key], childPath(path, key)))
            return false;
    }
    return true;
}
function rebaseValue(base, next, current, path) {
    if (sameValue(next, base))
        return current;
    const keyField = KEYED_LISTS.get(`${path}[]`);
    if (keyField &&
        Array.isArray(base) &&
        Array.isArray(next) &&
        Array.isArray(current)) {
        return rebaseList(base, next, current, keyField, `${path}[]`);
    }
    if (isPlainRecord(base) && isPlainRecord(next) && isPlainRecord(current)) {
        const merged = {};
        for (const key of new Set([
            ...Object.keys(current),
            ...Object.keys(next),
            ...Object.keys(base),
        ])) {
            const value = rebaseValue(base[key], next[key], current[key], childPath(path, key));
            if (value !== undefined)
                merged[key] = value;
        }
        return merged;
    }
    return next;
}
/**
 * A list a Config table holds by key, merged item by item: an item the
 * change left as it was keeps its stored state, an item both changed merges
 * like an object, an item the change added or removed is added or removed,
 * an item another writer added stays after the item it followed there, and
 * an item another writer removed stays removed unless the change edited it.
 * The change decides the order of the items it holds.
 */
function rebaseList(base, next, current, keyField, itemPath) {
    const before = itemsByKey(base, keyField, itemPath);
    const stored = itemsByKey(current, keyField, itemPath);
    const after = itemsByKey(next, keyField, itemPath);
    const merged = [];
    for (const [key, item] of after) {
        const was = before.get(key);
        if (was === undefined) {
            merged.push([key, item]);
            continue;
        }
        if (!stored.has(key)) {
            if (!sameValue(item, was))
                merged.push([key, item]);
            continue;
        }
        merged.push([key, rebaseValue(was, item, stored.get(key), itemPath)]);
    }
    let previous = null;
    for (const [key, item] of stored) {
        if (!after.has(key) && !before.has(key)) {
            const at = previous === null
                ? 0
                : merged.findIndex(([candidate]) => candidate === previous) + 1;
            merged.splice(at, 0, [key, item]);
        }
        if (merged.some(([candidate]) => candidate === key))
            previous = key;
    }
    return merged.map(([, item]) => item);
}
/** The items of a keyed list by their key; a list without unique keys is no keyed list. */
function itemsByKey(items, keyField, itemPath) {
    const byKey = new Map();
    for (const item of items) {
        const key = (0, app_settings_engine_1.settingsNaturalKey)(item, keyField);
        if (key === null || byKey.has(key)) {
            throw new app_settings_engine_1.SettingsMappingError(`${itemPath}: every item needs its own ${keyField}`);
        }
        byKey.set(key, item);
    }
    return byKey;
}
/** Equal values; null is a value of its own (e.g. no frame), not a missing one. */
function sameValue(a, b) {
    if (a === undefined || b === undefined)
        return a === b;
    return JSON.stringify(a) === JSON.stringify(b);
}
function isPlainRecord(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
/** The settings of one App Container from the rows of its settings tables. */
function appSettingsFromRows(viewId, rows) {
    const raw = appSettingsPartFromRows(viewId, rows);
    const artifact = raw['appArtifact'];
    if (artifact) {
        if (!raw['appBase']) {
            throw new app_settings_engine_1.SettingsMappingError(`App ${viewId}: artifact without appBase manifest`);
        }
        artifact['manifest'] = raw['appBase'];
    }
    return app_base_config_1.AppBaseConfigSchema.parse(raw);
}
